<template>
    <div class="my-panel" :class="{'no-border':!border,'width-half':half}">
      <div class="my-panel-wp">
        <div class="my-panel-header" v-if="title">
          <span class="my-panel-title" v-if="title">{{title}} <slot name="icon"></slot></span>
          <span class="my-panel-title2" v-if="title2">{{title2}}</span>
          <span class="my-panel-title3" v-if="title3">{{title3}}</span>
          <span class="my-panel-title2" v-if="goodstitle2">{{goodstitle2}}</span>
          <slot name="header"></slot>
          <i class="iconfont my-star" v-if="star">&#xe6ea;</i>
        </div>
        <slot></slot>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    title: [String, Number],
    title3: [String, Number],
    title2: [String, Number],
    goodstitle2: [String, Number],
    star: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: true
    },
    half: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl'

.my-panel
  flex-grow 1
  box-shadow: 0px 0px 4px rgba(204, 204, 204, 1)
  background #ffffff
  overflow hidden
  position relative
  flex-basis 100%
  .my-panel-wp
    padding: $panelPadding
  .my-panel-header
    display flex
    align-items center
    flex-flow nowrap row
    position: relative;
    .my-panel-title
      color: #333;
      font2()
      font-size 12px !important
    .my-panel-title2
      color #999999
    .my-panel-title3
      color $themeColor2
    .my-panel-title
    .my-panel-title2
    .my-panel-title3
      font-size $baseFontSize
      margin-right: 25px;
    .my-star
      position: absolute;
      right: 23px;
      font-size: 22px;
      color: #ff6666;
      top: 14px;
  &.no-border
    box-shadow none
  &.width-half
    flex-basis 50%
    box-sizing: border-box;
</style>



// WEBPACK FOOTER //
// src/components/base/panel/Panel.vue